// src/utils/fixAdminAccount.js
// ONE-TIME FIX: Grant admin privileges to pac623@icloud.com account
// This is needed because the account was created before the admin email was corrected

import { doc, updateDoc } from 'firebase/firestore';
import { db, auth } from '../config/firebase-config';

/**
 * Run this function ONCE from browser console to fix admin privileges
 *
 * Instructions:
 * 1. Log in as pac623@icloud.com
 * 2. Open DevTools console
 * 3. Import and run this function:
 *
 *    import fixAdminAccount from './utils/fixAdminAccount.js';
 *    fixAdminAccount();
 *
 * Or just run from console:
 *    window.fixAdminAccount()
 */
export const fixAdminAccount = async () => {
  try {
    const user = auth.currentUser;

    if (!user) {
      console.error('❌ No user logged in. Please log in first.');
      return;
    }

    if (user.email !== 'pac623@icloud.com') {
      console.error('❌ Current user is not pac623@icloud.com');
      console.log('Current user:', user.email);
      return;
    }

    console.log('🔧 Updating admin privileges for:', user.email);

    await updateDoc(doc(db, 'users', user.uid), {
      role: 'admin',
      isAdmin: true,
      subscriptionTier: 'elite',
    });

    // Update localStorage too
    localStorage.setItem('userRole', 'admin');
    localStorage.setItem('userTier', 'elite');
    localStorage.setItem('isAdmin', 'true');

    console.log('✅ Admin privileges applied to pac623@icloud.com');
    console.log('✅ Firestore document updated');
    console.log('✅ localStorage updated');
    console.log('🔄 Please refresh the page to see changes');

    return { success: true };
  } catch (error) {
    console.error('❌ Failed to update admin privileges:', error);
    return { success: false, error: error.message };
  }
};

// Make it available globally for console access
if (typeof window !== 'undefined') {
  window.fixAdminAccount = fixAdminAccount;
}

export default fixAdminAccount;
